<template>
  <tr class="cabinet__tbody-row">
    <td class="cabinet__tbody-column cabinet__tbody-column--planned-publication-date">
      {{ dateOfChange }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--purchase-name">
      {{ type }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--meaning">
      {{ oldValue }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--meaning">
      {{ newValue }}
    </td>
  </tr>
  <tr class="cabinet__tbody-row" />
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { formatterToRub, booleanFormatter } from '@/utils/helpers';
import dayjs from 'dayjs';

export default {
  name: 'PurchaseTableItem',
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    type() {
      return this.item.fieldName || '';
    },
    dateOfChange() {
      return this.item.dateOfChange ? dayjs(this.item.dateOfChange).format('DD.MM.YYYY HH:mm') : '';
    },
    oldValue() {
      return this.getValue(this.item.oldValue);
    },
    newValue() {
      return this.getValue(this.item.newValue);
    },
  },
  methods: {
    getValue(value) {
      if (value === null) {
        return 'Не указано';
      }
      switch (this.item.type) {
        case 'price':
          return formatterToRub(value);
        case 'dateTime':
          return dayjs(value).format('DD.MM.YYYY HH:mm');
        case 'date':
          return dayjs(value).format('DD.MM.YYYY');
        case 'boolean':
          return booleanFormatter(value);
        default:
          return value;
      }
    },
  },
};
</script>
